import { render, staticRenderFns } from "./CatalogFilters.vue?vue&type=template&id=852da170&scoped=true"
import script from "./CatalogFilters.vue?vue&type=script&lang=ts"
export * from "./CatalogFilters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852da170",
  null
  
)

export default component.exports